import { RenderComponentStrategy } from './render-component.strategy';

export class DiagonalBrace extends RenderComponentStrategy {
	componentKey = 'Stiffening_rib004';
}
